// extracted by mini-css-extract-plugin
module.exports = {"link":"pI0fG","primaryButton":"XJx8m"};